/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Tim Porritt
 * Created: 23/08/22
 */

import LoadWorkplanProvider from '@/components/contexts/WorkplanContext/providers/LoadWorkplanProvider';
import React, { ReactNode, useMemo } from 'react';

const WorkplanIdProvider = ({ children, id }: { children?: ReactNode; id: number }) => {
    const getPath = useMemo(() => () => `workplan/${id}`, [id]);
    return <LoadWorkplanProvider getPath={getPath}>{children}</LoadWorkplanProvider>;
};

export default WorkplanIdProvider;
